var $$ = $$ || {};

$$.FacebookPixel = class FacebookPixel {
	constructor () {}

	reachGoal(goal, data) {
		if (fbq) {
			if (data) {
				fbq('track', goal, data);
			} else {
				fbq('track', goal);
			}
		}
	}
};
